import { Route } from "vue-router";
import store from "@service/store";

////handle active streams
export const handleLiveStreams = (to: Route, from: Route) => {
    const liveItem = (store.state as any).formModal.elements.find((item: any) => item.isLive);
    if (liveItem && (liveItem.id != to.params.id) && (from.params.id != to.params.id)) {
        store.dispatch('formModal/minimize');
    }
}
